/* eslint-disable no-useless-escape */
import styles from "../../../_common/CrudFormStyles.module.scss";
import { useEffect } from "react";
import { Form, Input, Row, Col, Badge, Switch } from "antd";
import { translateKey as t } from "../../../../../locales/translation";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ClientsController } from "../../ClientsController";
import { observer } from "mobx-react";

const JobDataImportTab = observer(({ controller, form }: { controller: ClientsController; form: any }) => {
  useEffect(() => {}, []);

  const { selectedClient, isReadOnly, isSelectedReadOnly, formMode, formFieldsSize, showFieldsIcon } = controller;
  const { jobDataImport } = selectedClient;

  return (
    <>
      <Row className={styles.newRow} gutter={20} style={formFieldsSize === "small" && { marginTop: 0 }}>
        <Col span={12}>
          <Form.Item
            colon={false}
            label={
              <Badge dot={!jobDataImport.urlJobsAPI}>
                <span className={styles.formTitle}>{t("lblUrlJobsAPI", "Url Jobs API")}</span>
              </Badge>
            }
            name={["jobDataImport", "urlJobsAPI"]}
            // rules={[
            //   { required: true, whitespace: true, message: t("lblClientRefIsRequired", "Client Ref is required") },
            // ]}
          >
            <Input
              // onChange={handleInputChange}
              name="jobDataImport.urlJobsAPI"
              // disabled={isReadOnly || isSelectedReadOnly || formMode === "edit"}
              disabled
              autoFocus={formMode === "create"}
              maxLength={99}
              prefix={showFieldsIcon && <FontAwesomeIcon icon={faLock} style={{ color: "rgba(0,0,0,.25)" }} />}
              size={formFieldsSize}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            colon={false}
            label={
              <Badge dot={!jobDataImport.urlTokenAPI}>
                <span className={styles.formTitle}>{t("lblUrlTokenAPI", "Url Token API")}</span>
              </Badge>
            }
            name={["jobDataImport", "urlTokenAPI"]}
            // rules={[{ required: true, whitespace: true, message: t("lblNameIsRequired", "Name is required") }]}
          >
            <Input
              // onChange={handleInputChange}
              name="jobDataImport.urlTokenAPI"
              // disabled={isReadOnly || isSelectedReadOnly || formMode === "edit"}
              disabled
              autoFocus={formMode === "create"}
              maxLength={99}
              prefix={showFieldsIcon && <FontAwesomeIcon icon={faLock} style={{ color: "rgba(0,0,0,.25)" }} />}
              size={formFieldsSize}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={20} className={styles.newRow} style={formFieldsSize === "small" && { marginTop: 0 }}>
        <Col span={12}>
          <Form.Item
            colon={false}
            label={
              <Badge dot={!jobDataImport.inputFolderPath}>
                <span className={styles.formTitle}>{t("lblInputFolderPath", "Input Folder Path")}</span>
              </Badge>
            }
            name={["jobDataImport", "inputFolderPath"]}
            rules={[
              {
                required: true,
                whitespace: true,
                message: t("lblInputFolderPathIsRequired", "Input Folder Path is required"),
              },
            ]}
          >
            <Input
              name="jobDataImport.inputFolderPath"
              // onChange={handleInputChange}
              // disabled={isReadOnly || isSelectedReadOnly || formMode === "edit"}
              disabled
              maxLength={99}
              prefix={showFieldsIcon && <FontAwesomeIcon icon={faLock} style={{ color: "rgba(0,0,0,.25)" }} />}
              size={formFieldsSize}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            colon={false}
            label={
              <Badge dot={!jobDataImport.processedFolderPath}>
                <span className={styles.formTitle}>{t("lblProcessedFolderPath", "Processed Folder Path")}</span>
              </Badge>
            }
            name={["jobDataImport", "processedFolderPath"]}
            rules={[
              {
                required: true,
                whitespace: true,
                message: t("lblProcessedFolderPathIsRequired", "Processed Folder Path is required"),
              },
            ]}
          >
            <Input
              name="jobDataImport.processedFolderPath"
              // onChange={handleInputChange}
              // disabled={isReadOnly || isSelectedReadOnly || formMode === "edit"}
              disabled
              maxLength={99}
              prefix={showFieldsIcon && <FontAwesomeIcon icon={faLock} style={{ color: "rgba(0,0,0,.25)" }} />}
              size={formFieldsSize}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={20} className={styles.newRow} style={formFieldsSize === "small" && { marginTop: 0 }}>
        <Col span={12}>
          <Form.Item
            colon={false}
            label={
              <Badge dot={!jobDataImport.delimiter}>
                <span className={styles.formTitle}>{t("lbldelimiter", "Delimiter")}</span>
              </Badge>
            }
            name={["jobDataImport", "delimiter"]}
            rules={[
              {
                required: true,
                whitespace: true,
                message: t("lbldelimiterIsRequired", "Delimiter is required"),
              },
            ]}
          >
            <Input
              name="jobDataImport.delimiter"
              // onChange={handleInputChange}
              // disabled={isReadOnly || isSelectedReadOnly || formMode === "edit"}
              disabled
              maxLength={99}
              prefix={showFieldsIcon && <FontAwesomeIcon icon={faLock} style={{ color: "rgba(0,0,0,.25)" }} />}
              size={formFieldsSize}
            />
          </Form.Item>
        </Col>
        <Col span={12}></Col>
      </Row>
      <Row gutter={20} className={styles.newRow} style={formFieldsSize === "small" && { marginTop: 0 }}>
        <Col span={6}></Col>
        <Col span={6}>
          <Form.Item
            name={["jobDataImport", "active"]}
            label="Active"
            // valuePropName="jobDataImport.active"
          >
            <Switch disabled />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name={["jobDataImport", "readFromSFTP"]}
            label="Read From SFTP"
            // valuePropName="readFromSFTP"
          >
            <Switch disabled />
          </Form.Item>
        </Col>
        <Col span={6}></Col>
      </Row>
    </>
  );
});

export default JobDataImportTab ;
